import { useIdentity } from './IdentityProvider';

export function useCurrentAccountId() {
  const { currentAccountId } = useIdentity();
  return currentAccountId;
}
